<!-- 帮助中心 -->
<template>
  <div id="questionful">
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="queryParams" label-width="80px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="问题标题：" prop="questionTitle">
                <el-input
                  size="small"
                  v-model="queryParams.questionTitle"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="发布时间：" prop="time">
                <el-date-picker
                  size="small"
                  v-model="queryParams.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col v-if="user.userType !== '00'" :span="8" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
          <el-row v-if="user.userType === '00'" :gutter="24">
            <el-col :span="8">
              <el-form-item label="问题状态：" prop="questionStatus">
                <el-select
                  size="small"
                  clearable
                  v-model="queryParams.questionStatus"
                >
                  <template
                    v-for="(value, key) in dictData['sys_normal_disable']"
                  >
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="操作人员：" prop="updateBy">
                <el-input
                  size="small"
                  v-model="queryParams.updateBy"
                  clearable
                />
              </el-form-item>
            </el-col>

            <el-col :span="8" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
          <el-row v-else :gutter="24"> </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <el-tabs v-model="tabName" @tab-click="handleClick">
        <el-tab-pane
          v-for="(value, key) in dictData['question_type']"
          :key="value.value"
          :name="`${value.value}`"
          :title="value.label"
          :label="value.label"
        ></el-tab-pane>
      </el-tabs>
      <div style="overflow: hidden;">
        <span v-if="user.userType === '00'" style="float:left;">
          <el-button type="primary" size="small" @click="handleShowEditHelp({})"
            >新增</el-button
          >
        </span>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="loadData"
          :layout="'slot, total, sizes, prev, pager, next, jumper'"
        >
        </pagination>
      </div>

      <el-table :data="tableData">
        <el-table-column label="问题标题" prop="questionTitle">
          <template slot-scope="scope">
            <el-button type="text" @click="handleShowDetail(scope.row)"
              >{{ scope.row.questionTitle }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="问题分类" prop="questionType">
          <template slot-scope="scope">
            <span>{{ dictMap["question_type"][scope.row.questionType] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="user.userType == '00'"
          label="操作人员"
          prop="updateBy"
        ></el-table-column>
        <el-table-column label="发布时间" prop="createTime"></el-table-column>
        <el-table-column
          v-if="user.userType === '00'"
          label="操作"
          prop="oper"
          fixed="right"
          width="160"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="handleShowEditHelp(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="mini"
              @click="handleDeleteHelp(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>

    <el-dialog :close-on-click-modal="false"  
      :title="editDialog.title"
      :visible.sync="editDialog.dialogVisible"
    >
      <el-form
        :model="editDialog.questionForm"
        :rules="editDialog.rules"
        ref="questionForm"
        label-width="140px"
      >
        <el-form-item label="问题分类" prop="amazonSite">
          <el-select
            clearable
            v-model="editDialog.questionForm.questionType"
            placeholder="请选择问题分类"
          >
            <template v-for="(value, key) in dictData['question_type']">
              <el-option
                :key="key"
                :label="value.label"
                :value="value.value"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="问题标题" prop="questionTitle">
          <el-input v-model="editDialog.questionForm.questionTitle"></el-input>
        </el-form-item>
        <el-form-item label="问题内容" prop="content">
          <CKEditor4
            v-model="editDialog.questionForm.content"
            @getCkEditorInstance="getEditor"
            :config="editorConfig"
            @open="openUploadDialog"
          ></CKEditor4>
        </el-form-item>
        <el-form-item label="问题状态" prop="questionStatus">
          <el-radio-group v-model="editDialog.questionForm.questionStatus">
            <template v-for="(value, key) in dictData['sys_normal_disable']">
              <el-radio :label="value.value" :key="key">
                {{ value.label }}</el-radio
              >
            </template>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editDialog.dialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="handleSaveHelp"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <LocalUpload :ckData="localUploadData"></LocalUpload>
    <OnlineUpload :ckData="onlineUploadData"></OnlineUpload>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import {
  getHelpList,
  exportHelpList,
  addHelp,
  updateHelp,
  deleteHelp,
} from "@/api/sysSupport/help"
import CKEditor4 from "@/components/common/CKEditor"
import LocalUpload from "@/components/common/ckEditorUploadPage/localUpload"
import OnlineUpload from "@/components/common/ckEditorUploadPage/onlineUpload"

export default {
  name: "Help",
  components: {
    Breadcrumb,
    CKEditor4,
    LocalUpload,
    OnlineUpload,
  },
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        questionStatus: "1",
        updateBy: undefined,
        questionTitle: undefined,
        questionType: undefined,
        beginTime: undefined,
        endTime: undefined,
        time: [],
      },
      total: 0,
      tableData: [],
      editDialog: {
        title: "",
        dialogVisible: false,
        questionForm: {},
        rules: {
          questionType: [
            { required: true, message: "请选择问题分类", trigger: "blur" },
          ],
          questionTitle: [
            { required: true, message: "请输入问题标题", trigger: "blur" },
          ],
          // content: [
          //   { required: true, message: '请输入问题内容', trigger: 'blur' },
          // ],
          questionStatus: [
            { required: true, message: "请选择问题状态", trigger: "blur" },
          ],
        },
      },
      editor: null,
      editorConfig: {
        allowedContent: true, //设置为true，以防止CKEditor 4删除不允许的元素
        extraPlugins: ["uploadImg"],
        height: "300px",
        toolbar: [
          ["Maximize"],
          ["Bold", "Italic", "Underline", "Strike"],
          ["TextColor", "BGColor"],
          [
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Subscript",
            "Superscript",
          ],
          ["HorizontalRule", "RemoveFormat"],
          ["Undo", "Redo"],
          "/",
          ["Styles", "Format", "Font", "FontSize"],
          ["Table"],
          ["uploadImg"],
        ],
        language: "zh-cn",
        wordcount: {
          showCharCount: true,
        },
      },
      localUploadData: {
        visible: false,
        editor: null,
      },
      onlineUploadData: {
        visible: false,
        editor: null,
      },
      tabName: "01",
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
  },
  created() {
    this.loadData()
  },
  methods: {
    /** 查询问题列表 */
    loadData() {
      this.startLoading()
      if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = undefined
        this.queryParams.endTime = undefined
      }
      let queryParams = this._.clone(this.queryParams)
      queryParams.questionType = this.tabName

      let params = Object.assign({}, queryParams)
      delete params["time"]
      getHelpList(params).then((response) => {
        this.tableData = response.rows
        this.total = response.total
        this.endLoading()
      })
    },

    resetForm() {
      this.$refs["form"].resetFields()
    },

    /**显示编辑页面 */
    handleShowEditHelp(row) {
      this.editDialog.dialogVisible = true
      if (row.questionId) {
        this.editDialog.questionForm = Object.assign({}, row)
        this.editDialog.title = "编辑问题"
      } else {
        this.editDialog.questionForm = { isTop: "0" }
        this.editDialog.title = "新增问题"
        this.editDialog.questionForm.questionStatus = "1"
        this.$nextTick(() => {
          this.editor.setData("")
        })
      }
    },

    /**保存问题信息 */
    handleSaveHelp() {
      this.$refs["questionForm"].validate((valid) => {
        if (valid) {
          this.editDialog.questionForm.content = this.editor.getData()
          let form = this._.clone(this.editDialog.questionForm)
          if (this.editDialog.questionForm.questionId) {
            updateHelp(form).then((response) => {
              if (response.code == "200") {
                this.$message.success("修改成功！")
                this.editDialog.dialogVisible = false
                this.loadData()
              } else {
                this.$message.error("修改失败")
              }
            })
          } else {
            addHelp(form).then((response) => {
              if (response.code == "200") {
                this.$message.success("新增成功！")
                this.editDialog.dialogVisible = false
                this.loadData()
              } else {
                this.$message.error("新增失败")
              }
            })
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    /**删除问题 */
    handleDeleteHelp(row) {
      this.$confirm("确认删除问题？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteHelp(row.questionId).then((response) => {
          if (response.code == "200") {
            this.$message.success("删除成功！")
            this.loadData()
          } else {
            this.$message.error("删除失败！")
          }
        })
      })
    },
    /**详情 */
    handleShowDetail(row) {
      this.$router.push({
        path: "/system/advisory/help_detail",
        query: { questionId: row.questionId },
      })
    },

    download(row) {
      if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = undefined
        this.queryParams.endTime = undefined
      }
      let params = Object.assign({}, this.queryParams)
      delete params["time"]
      exportHelpList(params).then((response) => {
        if (response.code == "200") {
          this.$message.success("导出成功！")
        } else {
          this.$message.error("导出失败！")
        }
      })
    },

    getEditor(editor) {
      this.editor = this.localUploadData.editor = this.onlineUploadData.editor = editor
    },
    openUploadDialog(val) {
      if (val == "local") {
        this.localUploadData.visible = true
      } else if (val == "online") {
        this.onlineUploadData.visible = true
      }
    },
    handleClick() {
      this.loadData()
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
::v-deep .el-badge__content {
  position: relative;
  top: 6px;
  right: 30px;
}
</style>
